import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { Container } from '../Container';
import { useMediaQuery } from '@hooks/useMediaQuery';
import styles from './Popup.module.css';

export interface PopupProps {
    id?: string;
    show: boolean;
    onHide: () => void;
    header?: JSX.Element | JSX.Element[];
    desktopWidth: string;
    fullWidthOnMobile?: boolean;
    verticallyCentered?: boolean;
    children: JSX.Element | JSX.Element[];
}

export const Popup: FC<PopupProps> = ({
    id,
    show,
    onHide,
    header,
    desktopWidth,
    fullWidthOnMobile,
    verticallyCentered,
    children,
}) => {
    const headerHeight = document.querySelector('header')?.clientHeight || 0;

    return (
        <Modal
            id={id || undefined}
            show={show}
            onHide={onHide}
            className={`${styles.modal} ${fullWidthOnMobile ? styles['fullscreen-on-mobile'] : ''}`}
            dialogClassName={`${styles['modal-container']} ${verticallyCentered ? 'modal-dialog-centered' : styles['modal-default']}`}
            backdrop="static"
            keyboard={false}
            style={{ paddingTop: verticallyCentered ? '0' : `${headerHeight}px` }}>
            <Modal.Body className={styles['modal-body']} style={{ width: desktopWidth }}>
                <>
                    <CloseButton onHide={onHide} fullWidthOnMobile={fullWidthOnMobile} />
                    {header}
                </>
                {children}
            </Modal.Body>
        </Modal>
    );
};

export interface CloseButtonProps {
    onHide: () => void;
    fullWidthOnMobile?: boolean;
}

const CloseButton: FC<CloseButtonProps> = ({ onHide, fullWidthOnMobile }) => {
    const pageSize = useMediaQuery();

    const isSmallMobile = ['xs'].includes(pageSize);

    return (
        <div className={styles['close-button-container']}>
            {isSmallMobile && fullWidthOnMobile ? (
                <div className="sidebar-close">
                    <Container>
                        <button type="button" onClick={onHide} aria-label="Close">
                            <i className="fa-light fa-xmark" />
                        </button>
                    </Container>
                </div>
            ) : (
                <button
                    type="button"
                    className={`btn-close ${styles['btn-close']}`}
                    onClick={onHide}
                    aria-label="Close"
                    style={{ position: 'absolute', top: '0', right: '0', padding: '30px 30px 0 0' }}
                />
            )}
        </div>
    );
};
